module.exports = __webpack_public_path__ + "static/img/zb_tu2@2x.b4efc32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zb_tu2@2x.png
// module id = 79tY
// module chunks = 2